;(() => {
  const isCartPage = () => /\/cart\/?$/.test(location.pathname.toLowerCase())
  if (!isCartPage()) return

  const fireEvents = (delay) => {
    setTimeout(() => {
      document.dispatchEvent(new Event('main-cart::refresh'))
      document.dispatchEvent(new Event('cart::add'))
    }, delay)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fireEvents(1000), {
      once: true,
    })
  } else {
    fireEvents(800)
  }

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.js-plus') ||
      e.target.closest('.js-minus') ||
      e.target.closest('.main-cart__line-item__remove')
    ) {
      fireEvents(500)
      fireEvents(800)
    }
  })
})()

// Wrap OG prices in a span with price-wrapper attribute
;(() => {
  function wrapOgPrices() {
    document
      .querySelectorAll('.og-optout-wrap og-price[regular]')
      .forEach((el) => {
        if (!el.parentNode) return
        if (el.parentNode.hasAttribute('price-wrapper')) return
        const wrapper = document.createElement('span')
        wrapper.setAttribute('price-wrapper', '')
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
      })
  }

  const tick = (tries = 60) => {
    wrapOgPrices()
    if (tries > 0) setTimeout(() => tick(tries - 1), 100)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tick())
  } else {
    tick()
  }
})()

// Dispatch a custom event when OG Buy Once / Subscribe buttons are selected
;(() => {
  document.addEventListener('main-product:on-update', function (event) {
    ;[500, 800].forEach((delay) =>
      setTimeout(() => window.Abra?.render(), delay)
    )
  })

  document.addEventListener('click', function (event) {
    const optoutBtn = event.target.closest('.og-optout-btn, og-optout-button')
    const optinBtn = event.target.closest('.og-optin-btn, og-optin-button')
    const btn = optoutBtn || optinBtn

    if (!btn) return

    const offer = btn.closest('og-offer')
    const eventDetail = {
      bubbles: true,
      detail: {
        type: optoutBtn ? 'buy-once' : 'subscribe',
        price: btn.dataset.price || null,
        productHandle:
          btn.closest('[data-shopify-product-handle]')?.dataset
            .shopifyProductHandle ||
          offer?.querySelector('[data-product-handle]')?.dataset
            .productHandle ||
          null,
      },
    }

    const dispatchOgEvent = () => {
      window.dispatchEvent(
        new CustomEvent('og:purchase-type-selected', eventDetail)
      )
      window.Abra?.render()
    }

    dispatchOgEvent()
    setTimeout(dispatchOgEvent, 500)
  })
})()
